import { useContext } from "react";
import { authContext } from "../contexts/AuthProvider";
import { Link } from "react-router-dom";

const UserMenu = () => {
  const { isAuth, setIsAuth } = useContext(authContext);
  const logout = () => {
    localStorage.removeItem("token");
    if (isAuth === true) {
      setIsAuth(false);
    }
  };
  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px show user-menu-menu"
      data-kt-menu="true"
      data-popper-placement="bottom-end"
    >
      {/*begin::Menu item*/}
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          {/*begin::Avatar*/}
          <div className="symbol symbol-50px me-5">
            <img alt="Logo" src="../assets/media/avatars/user.png" />
          </div>
          {/*end::Avatar*/}

          {/*begin::Username*/}
          <div className="d-flex flex-column">
            <div className="fw-bold d-flex align-items-center fs-5">
              {process.env.REACT_APP_BRAND_NAME || ""}{" "}
            </div>

            <p className="fw-semibold text-muted text-hover-primary fs-7">
              Admin Panel{" "}
            </p>
          </div>
          {/*end::Username*/}
        </div>
      </div>
      {/*end::Menu item*/}

      {/*begin::Menu separator*/}
      <div className="separator my-2"></div>
      {/*end::Menu separator*/}

      {/*begin::Menu item*/}
      <div className="menu-item px-5">
        <Link to="/profile-settings" className="menu-link px-5">
          Profile Settings
        </Link>
      </div>
      {/*end::Menu item*/}

      {/*begin::Menu item*/}
      <div className="menu-item px-5">
        <Link to="/change-password" className="menu-link px-5">
          <span className="menu-text">Change Password</span>
        </Link>
      </div>
      {/*end::Menu item*/}

      {/*begin::Menu separator*/}
      <div className="separator my-2"></div>
      {/*end::Menu separator*/}

      {/*begin::Menu item*/}
      <div className="menu-item px-5">
        <div
          style={{ cursor: "pointer" }}
          onClick={logout}
          className="menu-link px-5"
        >
          Logout
        </div>
      </div>
      {/*end::Menu item*/}
    </div>
  );
};

export default UserMenu;
